import * as React from 'react';
import { SanityImage } from '../../../../../../../../../../../SanityImage';
import { useSanityNewsByUrlId } from '../../../../../../../../../../../../sanity';

export const ArticleImage = () => {
  const {
    data,
  } = useSanityNewsByUrlId();
  if (data == null) {
    return null;
  }
  return (
    <SanityImage
      image={data.image}
      maxPotentialWidth={1280}
      defaultAspectRatio={1.7375886524822695}
      forcedRatio={16 / 9}
    />
  );
};
